import { STRUCTURAL_HASH_COLUMNS } from "./display.js";
export function formatRows(rows, columns, options) {
    var _a;
    if (rows.length === 0)
        return '(0 rows)';
    const cols = columns !== null && columns !== void 0 ? columns : [...new Set(rows.flatMap((row) => Object.keys(row)))];
    const structural = (_a = options === null || options === void 0 ? void 0 : options.structuralColumns) !== null && _a !== void 0 ? _a : STRUCTURAL_HASH_COLUMNS;
    const rendered = rows.map((row) => cols.map((column) => renderCell(row[column], options === null || options === void 0 ? void 0 : options.ctx, structural.has(column) ? 'hash' : 'cell')));
    const widths = cols.map((column, i) => Math.max(column.length, ...rendered.map((row) => row[i].length)));
    const header = cols.map((column, i) => column.padEnd(widths[i])).join(' | ');
    const separator = widths.map((width) => '-'.repeat(width)).join('-+-');
    const body = rendered.map((row) => row.map((cell, i) => cell.padEnd(widths[i])).join(' | ')).join('\n');
    return `${header}\n${separator}\n${body}`;
}
export function formatRowsVertical(rows, columns, options) {
    var _a;
    if (rows.length === 0)
        return '(0 rows)';
    const cols = columns !== null && columns !== void 0 ? columns : [...new Set(rows.flatMap((row) => Object.keys(row)))];
    const structural = (_a = options === null || options === void 0 ? void 0 : options.structuralColumns) !== null && _a !== void 0 ? _a : STRUCTURAL_HASH_COLUMNS;
    return rows.map((row, index) => [
        `*** row ${index + 1} ***`,
        ...cols.map((column) => `${column}: ${renderCell(row[column], options === null || options === void 0 ? void 0 : options.ctx, structural.has(column) ? 'hash' : 'cell')}`),
    ].join('\n')).join('\n\n');
}
function renderCell(value, ctx, role = 'cell') {
    if (ctx !== undefined)
        return ctx.formatValue(value, { role });
    if (value === undefined)
        return '';
    if (value === null)
        return 'null';
    if (typeof value === 'object')
        return JSON.stringify(value);
    return String(value);
}
